var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIconCalendersvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.916611 9.99998C0.861775 10.0003 0.807415 9.98979 0.75665 9.96906C0.705884 9.94832 0.659711 9.91777 0.620777 9.87915C0.581724 9.84042 0.550726 9.79433 0.529573 9.74356C0.508419 9.69278 0.497528 9.63832 0.497528 9.58332C0.497528 9.52831 0.508419 9.47385 0.529573 9.42308C0.550726 9.3723 0.581724 9.32622 0.620777 9.28749L4.02494 5.88332C4.25903 5.64895 4.39051 5.33124 4.39051 4.99999C4.39051 4.66874 4.25903 4.35103 4.02494 4.11666L0.620777 0.712495C0.542317 0.634035 0.498239 0.527621 0.498239 0.416662C0.498239 0.305703 0.542317 0.199289 0.620777 0.120829C0.699237 0.0423693 0.805652 -0.00170898 0.916611 -0.00170898C1.02757 -0.00170898 1.13398 0.0423693 1.21244 0.120829L4.61661 3.52499C4.81062 3.71852 4.96455 3.94841 5.06958 4.20152C5.17461 4.45462 5.22867 4.72596 5.22867 4.99999C5.22867 5.27402 5.17461 5.54536 5.06958 5.79846C4.96455 6.05157 4.81062 6.28146 4.61661 6.47499L1.21244 9.87915C1.17351 9.91777 1.12734 9.94832 1.07657 9.96906C1.02581 9.98979 0.971447 10.0003 0.916611 9.99998Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconCalendersvg);
export default __webpack_public_path__ + "static/media/RightIconCalender.svg.c1b7eb3a4ecbe88b40f9d36d360e862c.svg";
export { ForwardRef as ReactComponent };